export default __webpack_public_path__ + "static/media/logo.3e04d844.svg";